export const validation = values =>{
    const errors={}
    if(!values.name){
        return errors.name="Please Provide Name";
    }
    else if(! values.email){
        return errors.email="please fill the email id";
    }
    else if(!values.mobileNumber){
        return errors.mobileNumber="please fill the mobile number"
    }
    else if(!values.plot){
        return errors.plot="please select the plot option";
    }
    
    else if(!values.units){
        return errors.units="please enter the units"
    }
    else if(!values.pricePerUnit){
        return errors.pricePerUnit="plase enter the price per unit"
    }
    else if (values.legalOwner!==true)
    {
        return errors.legalOwner="please check the document verifications"
    }
    else if (values.documentValuation!==true)
    {
        return errors.documentValuation="please check the document verifications"
    }
    else if (values.propExProcess!==true)
    {
        return errors.propExProcess="please check the document verifications"
    }
    

    return errors;
    
}
export const addPropertyValidation = values =>{
    const addPropertyErrors={}
    if(!values.propetyName){
        return addPropertyErrors.propetyName="Please Enter Property Name"
    }
    else if(!values.propertyType){
        return addPropertyErrors.propetyName="Please Select Property Type"
    }
    return addPropertyErrors;

}
export const contactFormValidation = values =>{
    const contactPerson={}
    if(!values.name){
        return contactPerson.name="Please Enter Name"
    }
    else if(!values.email){
        return contactPerson.email="Please Enter Email id"
    }
    return contactPerson;

}